import { useRef } from "react";
import { createContext, useContext, useMemo } from "react";
import { useLocalStorage } from "./useLocalStorage";
import { googleLogout } from "@react-oauth/google";
import { signOut } from "./SignOut.jsx";
import { Arrayify } from "../Functions/utils.jsx";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const subscriber_r = useRef();
  const avatar_r = useRef();
  const email_r = useRef();
  const subuuid_r = useRef();
  const startupHelp_r = useRef();
  const features_r = useRef();
  const admin_r = useRef();
  const [subscriber_, setSubscriber] = useLocalStorage("subscriber", null);
  const [subscriberPicture_, setSubscriberPicture] = useLocalStorage(
    "subscriberPicture",
    null
  );

  // call this function when you want to authenticate the subscriber
  const login_ = async (data) => {
    console.log("login::" + data);
    setSubscriber(data);
    subscriber_r.current = data;
  };

  const avatar_ = async (data) => {
    console.log("avatar: " + data);
    setSubscriberPicture(data);
    avatar_r.current = data;
  };
  const email_ = async (data) => {
    console.log("email: " + data);
    email_r.current = data;
  };
  const subuuid_ = async (data) => {
    console.log("subuuid: " + data);
    subuuid_r.current = data;
  };
  const startupHelp_ = async (data) => {
    console.log("startupHelp: " + data);
    startupHelp_r.current = data;
  };
  const features_ = async (data) => {
    console.log("features: " + data);
    features_r.current = Arrayify(data);
  };

  const admin_ = async (data) => {
    console.log("admin: " + data);
    admin_r.current = data;
  };
  // call this function to sign out logged in subscriber
  const logout_ = () => {
    subscriber_r.current = null;
    avatar_r.current = null;
    subuuid_r.current = null;
    email_r.current = null;
    startupHelp_r.current = null;
    admin_r.current = null;
    setSubscriberPicture(null);
    setSubscriber(null);
    signOut();
    googleLogout();

  };

  const value = useMemo(
    () => ({
      subscriber_r,
      subscriber_,
      login_,
      logout_,
      avatar_,
      email_,
      subuuid_,
      startupHelp_,
      admin_,
      features_,
      subscriberPicture_,
      subscriberPicture_,
      subscriberPicture_,
      avatar_r,
      email_r,
      subuuid_r,
      startupHelp_r,
      admin_r,
      features_r,

    }),
    [subscriber_]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
